'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customScrollbars = require('./custom-scrollbars');

var _customScrollbars2 = _interopRequireDefault(_customScrollbars);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./scroll-area.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-scroll-area'; // Using bowser here because the react-scrollbars-custom component relies on it, so it is a dependency already.
// Since we are using our own modified copy of react-scrollbars-custom, we could rework its browser detection
// and get rid of the bowser dependency, but for now I am choosing not to do this, in order to limit changes to
// those files to only absolutely required changes, so that updates from react-scrollbars-custom could be more
// easily performed if needed.

var browser = global.window && global.window.navigator && _bowser2.default.getParser(global.window.navigator.userAgent);

var ScrollArea = function (_Component) {
  _inherits(ScrollArea, _Component);

  function ScrollArea(props) {
    _classCallCheck(this, ScrollArea);

    var _this = _possibleConstructorReturn(this, (ScrollArea.__proto__ || Object.getPrototypeOf(ScrollArea)).call(this, props));

    _this.showTracks = function () {
      _this.scrollOpacity = 1;
      _this.scrollbar.current.trackXEl.style.opacity = _this.scrollOpacity;
      _this.scrollbar.current.trackYEl.style.opacity = _this.scrollOpacity;
      _this.scrollbar.current.wrapperEl.style.marginRight = 8;
      _this.hideTracksAfterDrag = false;
      _this.dragEndTO && clearTimeout(_this.dragEndTO);
      _this.dragEndTO = null;
    };

    _this.hideTracks = function () {
      if (_this.scrollbar.current.thumbXEl.classList.contains('dragging') || _this.scrollbar.current.thumbYEl.classList.contains('dragging')) {
        _this.hideTracksAfterDrag = true;
        return;
      }

      _this.scrollOpacity = 0;
      _this.scrollbar.current.trackXEl.style.opacity = _this.scrollOpacity;
      _this.scrollbar.current.trackYEl.style.opacity = _this.scrollOpacity;
      _this.scrollbar.current.wrapperEl.style.marginRight = 0;
      _this.dragEndTO && clearTimeout(_this.dragEndTO);
      _this.dragEndTO = null;
    };

    _this.handleDragEnd = function () {
      if (_this.hideTracksAfterDrag) {
        _this.hideTracksAfterDrag = false;
        _this.dragEndTO = setTimeout(_this.hideTracks, 500);
      }
    };

    _this.onScrollStart = function (scrollValues) {
      if (!_this.programmaticScrollInProgress) {
        _this.scrollOpacityAtStart = _this.scrollOpacity;

        _this.showTracks();
      }

      if (_this.props.onScrollStart) {
        _this.props.onScrollStart(scrollValues);
      }
    };

    _this.onScrollStop = function (scrollValues) {
      if (!_this.programmaticScrollInProgress && _this.scrollOpacityAtStart === 0) {
        _this.hideTracks();
      }

      _this.programmaticScrollInProgress = false;

      if (_this.props.onScrollStop) {
        _this.props.onScrollStop(scrollValues);
      }
    };

    _this.onWheel = function (event) {
      if (_this.props.flipY) {
        var isFirefox = browser.parsedResult.browser.name === 'Firefox';

        var _this$getScrollValues = _this.getScrollValues(),
            scrollHeight = _this$getScrollValues.scrollHeight,
            scrollTop = _this$getScrollValues.scrollTop;

        var y = scrollTop - (isFirefox ? event.deltaY * 30 : event.deltaY);

        if (y > scrollHeight) {
          y = scrollHeight;
        }

        if (_this.scrollbar && _this.scrollbar.current) {
          _this.scrollbar.current.scrollTo(y);
        }

        event.preventDefault();
        event.stopPropagation();
      }

      if (_this.props.onWheel) return _this.props.onWheel(event);
    };

    _this.state = {
      explicitHeight: null
    }; // these are not included in state because they do not explicitly drive render(),
    // nor do we want to cause re-rendering when they change

    _this.scrollOpacity = 0;
    _this.scrollOpacityAtStart = 0;
    _this.hideTracksAfterDrag = false;
    _this.dragEndTO = null;
    _this.programmaticScrollInProgress = false;
    _this.scrollbar = _react2.default.createRef();
    return _this;
  }

  _createClass(ScrollArea, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollbar && this.scrollbar.current) {
        this.scrollbar.current.wrapperEl.removeEventListener('wheel', this.onWheel);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // this is needed in order to emulate the behavior of ScrollView where it will grow to the
      // size of the content, up to a max height, then start scrolling.  Requires the content
      // do be wrapped in a single div
      if (this.props.growWithContentY && this.scrollbar && this.scrollbar.current) {
        if (this.scrollbar.current.contentEl.children && this.scrollbar.current.contentEl.children.length === 1) {
          var heightEl = this.scrollbar.current.contentEl.firstChild;

          for (var i = 0; i < this.props.growWithContentLevel - 1; i++) {
            if (heightEl.children && heightEl.children.length === 1) {
              heightEl = heightEl.firstChild;
            }
          }

          if (heightEl && heightEl.clientHeight !== this.scrollbar.current.wrapperEl.clientHeight && heightEl.clientHeight !== this.state.explicitHeight) {
            this.setState({
              explicitHeight: heightEl.clientHeight
            });
          }
        } else {
          console.warn('Prop "growWithContentY" passed to ScrollArea, but content contains more than one element.  Please wrap content in an enclosing DIV');
        }
      }

      if (this.scrollbar && this.scrollbar.current && (this.props.flipY || this.props.onWheel)) {
        this.scrollbar.current.wrapperEl.addEventListener('wheel', this.onWheel, {
          passive: false
        });
      }
    } // don't show the scrollbars when the app is programmatically adjusting the scroll values
    // only hide the scrollbars when a scroll finishes if they were hidden already when it started

  }, {
    key: 'getScrollComponent',
    value: function getScrollComponent() {
      return this.scrollbar.current;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(x, y) {
      if (this.scrollbar && this.scrollbar.current) {
        this.programmaticScrollInProgress = true;
        this.scrollbar.current.scrollTo(x, y);
      }
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      if (this.scrollbar && this.scrollbar.current) {
        this.programmaticScrollInProgress = true;
        this.scrollbar.current.scrollToTop();
      }
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      if (this.scrollbar && this.scrollbar.current) {
        this.programmaticScrollInProgress = true;
        this.scrollbar.current.scrollToBottom();
      }
    }
  }, {
    key: 'getScrollValues',
    value: function getScrollValues() {
      if (this.scrollbar && this.scrollbar.current) {
        return this.scrollbar.current.getScrollValues();
      } else return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          contentContainerStyle = _props.contentContainerStyle,
          flipY = _props.flipY,
          noScrollX = _props.noScrollX,
          noScrollY = _props.noScrollY,
          onScroll = _props.onScroll,
          scrollDetectionThreshold = _props.scrollDetectionThreshold,
          scrollEnabled = _props.scrollEnabled,
          style = _props.style,
          trackXClassName = _props.trackXClassName,
          trackXStyle = _props.trackXStyle,
          trackYClassName = _props.trackYClassName,
          trackYStyle = _props.trackYStyle,
          shouldStretchModal = _props.shouldStretchModal;
      trackXStyle.opacity = 0;
      trackYStyle.opacity = 0;
      if (!trackXStyle.left) trackXStyle.left = 0;
      if (!trackYStyle.top) trackYStyle.top = 0;
      if (!trackXStyle.width) trackXStyle.width = '100%';
      if (!trackYStyle.height) trackYStyle.height = '100%';
      var scrollStyle = style ? style : {};

      if (this.state.explicitHeight) {
        scrollStyle.height = this.state.explicitHeight;
      }

      return _react2.default.createElement(_customScrollbars2.default, {
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, STYLE_BASE + '-base', true), _classNames)),
        style: scrollStyle,
        onScroll: onScroll,
        onWheel: this.onWheel,
        removeTracksWhenNotUsed: false,
        trackYProps: {
          className: trackYClassName,
          style: trackYStyle,
          onMouseOver: this.showTracks,
          onMouseOut: this.hideTracks
        },
        trackXProps: {
          className: trackXClassName,
          style: trackXStyle,
          onMouseOver: this.showTracks,
          onMouseOut: this.hideTracks
        },
        thumbXProps: {
          onDragEnd: this.handleDragEnd
        },
        thumbYProps: {
          onDragEnd: this.handleDragEnd
        },
        contentProps: {
          style: contentContainerStyle,
          onMouseOver: this.showTracks,
          onMouseOut: this.hideTracks
        },
        wrapperProps: {
          style: {
            marginRight: 0
          }
        },
        onScrollStart: this.onScrollStart,
        onScrollStop: this.onScrollStop,
        scrollDetectionThreshold: scrollDetectionThreshold,
        flipY: flipY,
        noScroll: !scrollEnabled,
        noScrollX: noScrollX,
        noScrollY: noScrollY,
        ref: this.scrollbar,
        shouldStretchModal: shouldStretchModal
      }, children);
    }
  }]);

  return ScrollArea;
}(_react.Component);

ScrollArea.propTypes = {
  contentContainerStyle: _propTypes2.default.object,
  className: _propTypes2.default.string,
  growWithContentY: _propTypes2.default.bool,
  growWithContentLevel: _propTypes2.default.number,
  noScrollX: _propTypes2.default.bool,
  noScrollY: _propTypes2.default.bool,
  onScroll: _propTypes2.default.func,
  onScrollStart: _propTypes2.default.func,
  onScrollStop: _propTypes2.default.func,
  onWheel: _propTypes2.default.func,
  scrollDetectionThreshold: _propTypes2.default.number,
  scrollEnabled: _propTypes2.default.bool,
  trackXStyle: _propTypes2.default.object,
  trackYStyle: _propTypes2.default.object
};
ScrollArea.defaultProps = {
  growWithContentY: false,
  growWithContentLevel: 1,
  noScrollX: false,
  noScrollY: false,
  scrollEnabled: true,
  scrollDetectionThreshold: 500,
  trackXStyle: {},
  trackYStyle: {}
};
exports.default = ScrollArea;